
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"500","height":"62","viewBox":"0 0 506 62","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#CCC","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M410.371 10C467.981 15.16 505 23.357 505 32.464 505 48.25 391.857 61 253 61S1 48.25 1 32.464C1 23.16 34.096 15.206 94.782 10"}}),_c('path',{attrs:{"d":"M424.156 32L410 9.857 441 1"}})])])
          )
        }
      }
    